module.exports = __webpack_public_path__ + "img/carrousel-intervensionista-12.d7836a73.png";